var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasuring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .measuring-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:9.9999;stroke-miterlimit:15.118;}\r\n    ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "measuring-st0",
    cx: 180,
    cy: 180,
    r: 158.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M179.9,112.3c-16.8,0-33.2,4.7-47.5,13.4c-1.2,0.8-2,2.2-1.9,3.7c0.1,1.5,0.9,2.8,2.2,3.5s2.9,0.7,4.2,0 c13-7.9,27.8-12.2,43-12.2s30.1,4.2,43.1,12.2c1.3,0.8,2.9,0.8,4.2,0.1s2.2-2.1,2.2-3.6s-0.7-2.9-2-3.7 C213.1,117,196.7,112.3,179.9,112.3L179.9,112.3z M179.9,136c-13.1,0-25.9,3.8-36.9,11.1c-1,0.6-1.7,1.6-2,2.7 c-0.3,1.1,0,2.3,0.6,3.3s1.6,1.6,2.8,1.8c1.1,0.2,2.3-0.1,3.2-0.7c9.6-6.3,20.8-9.6,32.3-9.6s22.7,3.3,32.3,9.6 c0.9,0.7,2.1,0.9,3.2,0.7c1.1-0.2,2.1-0.9,2.8-1.8c0.6-1,0.8-2.1,0.6-3.3c-0.3-1.1-0.9-2.1-1.9-2.7 C205.9,139.9,193.1,136,179.9,136L179.9,136z M179.9,159.2c-9.7,0-19.1,3.2-26.8,9.1l0,0c-1,0.7-1.6,1.7-1.8,2.8s0.1,2.3,0.8,3.2 s1.8,1.5,2.9,1.6c1.2,0.1,2.3-0.2,3.2-1c6.2-4.8,13.8-7.3,21.7-7.3c7.8,0,15.5,2.6,21.7,7.3l0,0c1.2,0.9,2.8,1.1,4.2,0.5 s2.4-1.9,2.6-3.4c0.2-1.5-0.4-3-1.6-3.9C199.1,162.3,189.6,159.2,179.9,159.2L179.9,159.2z M180,182.2c-10.7,0-19.4,8.7-19.4,19.4 c0,9.2,6.5,16.9,15.2,18.9v22.9c0,1.1,0.4,2.2,1.2,3.1s1.9,1.3,3,1.3s2.2-0.5,3-1.3s1.2-1.9,1.2-3.1v-22.8 c8.6-1.9,15.2-9.7,15.2-18.9C199.4,191,190.6,182.2,180,182.2L180,182.2z M180,190.7c6.1,0,10.9,4.8,10.9,10.9 c0,6.1-4.8,10.9-10.9,10.9c-6.1,0-11-4.8-11-10.9S173.9,190.7,180,190.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasuring);
export default __webpack_public_path__ + "static/media/measuring.03611e8d39f7ef9986b6beef3a12a1dc.svg";
export { ForwardRef as ReactComponent };